import ReactDOM from "react-dom/client";
import React from 'react';

// ⚠️ Sentry 必须在所有其他 import 之前初始化
import { initSentry } from './lib/sentry';

initSentry();

import App from "./App.jsx";
import "./index.css";
import "./styles/travel-os-design-system.css";

// ★ 性能监控初始化
import { initPerformanceMonitor } from './lib/performance';

// 创建根节点并渲染应用
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ★ DOM 就绪后初始化性能监控
if (document.readyState === 'complete') {
  initPerformanceMonitor();
} else {
  window.addEventListener('load', () => {
    initPerformanceMonitor();
  });
}
